import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { PromosBanner as PromosBannerComponent } from '../../../components/PromosBanner';
import { getGaLabel } from '../../../selectors/analytics';
import { getDiscountMortgage } from '../../../selectors/newbuilding';
import { useApplicationContext } from '../../../utils/withApplicationContext';
import { CallButton } from '../../CallButton';
import { trackShowPhoneInBannerClick } from '../tracking';

export const PromosBanner: React.FC = () => {
  const { config } = useApplicationContext();
  const defaultText = 'Узнайте про персональные условия и дополнительные скидки при покупке квартиры у застройщика';
  const discountMortgageText = config.getStrict<string>('Newbuilding.DiscountMortgageBanner.Text');
  const isDiscountMortgageValid = config.getStrict<boolean>('Newbuilding.DiscountMortgageBanner.Enabled');
  const isDiscountMortgage = useSelector(getDiscountMortgage);
  const text = isDiscountMortgageValid && isDiscountMortgage ? discountMortgageText : defaultText;
  const gaLabel = useSelector(getGaLabel);

  const trackShowPhone = React.useCallback(() => {
    trackShowPhoneInBannerClick(gaLabel);
  }, [gaLabel]);

  return (
    <PromosBannerComponent
      text={text}
      contactsButton={
        <CallButton
          placeType="promosBanner"
          onShowPhoneClick={trackShowPhone}
          openContactsStyles={{ size: 'XS' as const, theme: 'fill_secondary' }}
          showPhoneStyles={{
            size: 'XS' as const,
            theme: 'fill_secondary',
            beforeIcon: <IconCommunicationPhone16 color="icon-main-default" />,
          }}
          SinglePhoneComponent={undefined}
          singlePhoneButtonText="Контакты застройщика"
        />
      }
    />
  );
};
